// Notice/alert/error slide up animations

document.addEventListener('turbolinks:load', () => {
  window.setTimeout(() => {
    setupBanners();
  }, 1000); // for some reason we need to be delay it a bit
});

function setupBanners(){
  window.setTimeout(() => {
    let notice = document.querySelector('.notice');
    if (notice) notice.classList.add('hidden');

    let alert = document.querySelector('.alert');
    if (alert) alert.classList.add('hidden');

    let error = document.querySelector('.error');
    if (error) error.classList.add('hidden');
  }, 5000);

  let dismissNotices = document.querySelectorAll(".dismissNotice");
  dismissNotices.forEach((dismissNotice) => {
  console.log(dismissNotice)
    dismissNotice.addEventListener('click', () => {
      console.log("yaeh")
      let el = document.querySelector('.notice');
      if (el) el.classList.add('hidden');
    });
  })
  let dismissAlert = document.querySelector(".dismissAlert");
  if (dismissAlert) dismissAlert.addEventListener('click', () => {
    let el = document.querySelector('.alert');
    if (el) el.classList.add('hidden');
  });
  let dismissError = document.querySelector(".dismissError");
  if (dismissError) dismissError.addEventListener('click', () => {
    let el = document.querySelector('.error');
    if (el) el.classList.add('hidden');
  });
}
